export const searchFormOption = function () {
    return [
		{
		  prop: "keyword",
		  label: "关键字",
		  type: "input",
		  placeholder: "流水号/车牌号/车架号",
		  width: "20%",
		},
		{
		  prop: "carType",
		  label: "车型",
		  type: "select",
		  width: "20%",
		  options: this.$store.state.app.carType,
		},
        {
            prop: 'orgId',
            label: '出单机构',
            type: 'cascader',
            placeholder: '请选择出单机构',
            propConfig: {
                children: 'children',
                label: 'orgName',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
            },
            options: this.orgOption
        },
		{
		    prop: 'date',
		    label: '出单时间',
			width: "25%",
		    type: 'range-date-time',
		}
    ]
}

export default {}